module.exports = __webpack_public_path__ + "assets/b7c72772d98d3e17697d549fbc75f975.mp3";